import axiosInstance from "../../Utils/axiosInstance";
import { getLoggedInEmail, isManagement } from "../../Utils/Constant";

export const getProposalData = async (payload: string) => {
    try {
        const response = await axiosInstance.get(
            `api/general/getCompanyRFQProposals?email=${getLoggedInEmail()}`
        );
        return response?.data;
        // if (isManagement()) {
        //   const response = await axiosInstance.get(
        //     `api/general/getCompanyRFQProposals`
        //   );
        //   return response?.data;
        // } else {
        //   const response = await axiosInstance.get(
        //     `api/key_account_management/getCompanyRFQProposal?userEmail=${getLoggedInEmail()}`
        //   );
        //   return response?.data;
        // }
    } catch (error) {
        console.error("Error:", error?.response?.data);
        return error?.response?.data;
    }
};

export const getCoPoData = async () => {
    try {
        const response = await axiosInstance.get(
            `api/general/getCoPoTableData?email=${getLoggedInEmail()}`
        );
        return response?.data;
    } catch (error) {
        console.error("Error:", error?.response?.data);
        return error?.response?.data;
    }
};
